import { kebabCase } from 'es-toolkit';
import React, { Component } from 'react';
import { connect, ResolveThunks } from 'react-redux';
import { Box, Typography } from '@mui/material';

import { IconTool } from '@paragon/client-tools';

import { onPlaceObject } from '../actions/annotations';
import { showPlaceTextPrompt } from '../actions/popup';

export const PLACEABLE_OBJECTS = {
  callout:
    'https://paragontruss.blob.core.windows.net/paragonpdfimages/max-callout.png_92e78630-2a25-4af4-962e-af3497baee71/max-callout.png',
  arrow:
    'https://paragontruss.blob.core.windows.net/paragonpdfimages/max-arrow.png_22937494-6aee-4d42-8ad8-46fccee84303/max-arrow.png',
  line: 'https://paragontruss.blob.core.windows.net/paragonpdfimages/max-line.png_fbaa0a0e-80c4-4288-b55e-71228c859e50/max-line.png',
  dashedLine:
    'https://paragontruss.blob.core.windows.net/paragonpdfimages/max-dashed-line.png_2ddba0aa-d51d-43ab-925b-18acba9c1a0f/max-dashed-line.png',
  blackCloud:
    'https://paragontruss.blob.core.windows.net/paragonpdfimages/Black Cloud.png_0f11a3b2-60e1-4592-917d-0637b28fbc3d/Black Cloud.png',
  redCloud:
    'https://paragontruss.blob.core.windows.net/paragonpdfimages/Red Cloud.png_fea41f94-6dc3-4cca-a984-16b71e75427d/Red Cloud.png',
  blackRectangle:
    'https://paragontruss.blob.core.windows.net/paragonpdfimages/max-rectangle.png_4bd98c99-8757-46a3-948e-b9f83d11098a/max-rectangle.png',
  redRectangle:
    'https://paragontruss.blob.core.windows.net/paragonpdfimages/max-red-rectangle.png_8cb255d9-ae00-4b75-9338-6722b5700058/max-red-rectangle.png',
  hollowBlackRectangle:
    'https://paragontruss.blob.core.windows.net/paragonpdfimages/Black Rectangle.png_86665fe6-5b26-41fb-af43-30e51ad1decb/Black Rectangle.png',
  hollowRedRectangle:
    'https://paragontruss.blob.core.windows.net/paragonpdfimages/Red Rectangle.png_888308eb-9182-4fda-8f05-e661e52aa8de/Red Rectangle.png',
  blackEllipse:
    'https://paragontruss.blob.core.windows.net/paragonpdfimages/max-ellipse.png_82ca6998-6d75-4906-aadd-eb747fad806e/max-ellipse.png',
  redEllipse:
    'https://paragontruss.blob.core.windows.net/paragonpdfimages/max-red-ellipse.png_d4471859-f870-4c71-a1c4-3ffa19dfa7f9/max-red-ellipse.png',
  hollowBlackEllipse:
    'https://paragontruss.blob.core.windows.net/paragonpdfimages/Black Ellipse.png_afe3ca7d-7f55-4bfa-9b34-ed06e47e0fd4/Black Ellipse.png',
  hollowRedEllipse:
    'https://paragontruss.blob.core.windows.net/paragonpdfimages/Red Ellipse.png_b740ff4a-13e6-4e0e-8c12-837e55420cf7/Red Ellipse.png',
};

interface OwnProps {
  onItemChosen: () => void;
}
type DispatchProps = ResolveThunks<typeof actionCreators>;

class PlaceObjectMenu extends Component<OwnProps & DispatchProps> {
  onPlaceText() {
    this.props.onItemChosen();
    this.props.showPlaceTextPrompt();
  }

  onPlaceObject(name: keyof typeof PLACEABLE_OBJECTS) {
    this.props.onItemChosen();
    this.props.onPlaceObject(name);
  }

  render() {
    const placeObjectButtons = Object.keys(PLACEABLE_OBJECTS).map((key) => (
      <Box
        component="button"
        type="submit"
        sx={{ height: '48px', width: '48px' }}
        onClick={this.onPlaceObject.bind(this, key as keyof typeof PLACEABLE_OBJECTS)}
        key={key}
      >
        <Box component="span" sx={{ m: 0, minWidth: '16px', minHeight: '16px', width: '100%', height: '100%' }}>
          <IconTool iconName={`#${kebabCase(key)}`} />
        </Box>
      </Box>
    ));

    return (
      <div>
        <Typography>Basic Shapes</Typography>

        <div className="placeObjectMenu">
          <Box
            component="button"
            type="submit"
            sx={{ height: '48px', width: '48px' }}
            onClick={this.onPlaceText.bind(this)}
          >
            <Box component="span" sx={{ m: 0, minWidth: '16px', minHeight: '16px', width: '100%', height: '100%' }}>
              <IconTool iconName="#textbox" />
            </Box>
          </Box>

          {placeObjectButtons}
        </div>
      </div>
    );
  }
}

const actionCreators = {
  onPlaceObject,
  showPlaceTextPrompt,
};

export default connect(null, actionCreators)(PlaceObjectMenu);
